import { configureStore } from "@reduxjs/toolkit";
import permissionsReducer from "../slices/permissionsSlice";
import projectReducer from "../slices/projectSlice";
import jobReducer from "../slices/jobSlice";
import loaderReducer from "../slices/loaderSlice";
import availableTagsReducer from "../slices/availableTagsSlice";

const store = configureStore({
  reducer: {
    permissions: permissionsReducer,
    data: projectReducer,
    job: jobReducer,
    loader: loaderReducer,
    availableTags: availableTagsReducer,
  },
});

export default store;
